import {toast} from 'react-toastify'
import Apiservices from '../../lib/ApiServices'
import ApisMethods from './apisMethods'

const Vendor = {
  get: (callback: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/profile`, callback, setIsLoading)
  },

  put: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/profile`, data, callback, setIsLoading)
  },
  _dialCode: (phoneCode: any) => {
    if (typeof phoneCode === 'string') {
      return phoneCode
    }
    return phoneCode?.phone_code || phoneCode?.country_code || '+961'
  },
  signin: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(
      `/vendor/login`,
      {...data, phone_code: Vendor._dialCode(data.phone_code)},
      callback,
      setIsLoading
    )
  },
  forgetPassword: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(
      `/vendor/forget-password`,
      {...data, phone_code: Vendor._dialCode(data.phone_code)},
      callback,
      setIsLoading
    )
  },
  resendOtp: async (
    data: any,
    onSuccess: any,
    onRateLimit: any,
    setIsLoading: any
  ) => {
    try {
      setIsLoading(true)
      const res = await Apiservices.post(`/vendor/resend-otp`, {
        ...data,
        phone_code: Vendor._dialCode(data.phone_code),
      })
      toast.success('Code sent')
      onSuccess(res.data)
    } catch (error: any) {
      const body = error?.response?.data
      if (body?.error === 'too_many_attempts' || error?.response?.status === 429) {
        onRateLimit(body)
      } else if (!error?.response) {
        toast.error('Network error, please check your internet connection.')
      } else {
        toast.error(body?.message)
      }
    } finally {
      setIsLoading(false)
    }
  },
  checkCode: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(
      `/vendor/check-reset-code`,
      {
        mobile: data.mobile,
        code: String(data.code ?? ''),
        phone_code: Vendor._dialCode(data.phone_code),
      },
      callback,
      setIsLoading
    )
  },
  resetPassword: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(
      `/vendor/reset-password`,
      {
        mobile: data.mobile,
        code: String(data.code ?? ''),
        phone_code: Vendor._dialCode(data.phone_code),
        new_password: data.new_password,
        new_password_confirmation: data.new_password_confirmation,
      },
      callback,
      setIsLoading
    )
  },
  logout: (callback: any, setIsLoading: any) => {
    
    ApisMethods().post(`/vendor/logout`, {}, callback, setIsLoading)
  },
  resetVendorPassword: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/profile/edit-password`, data, callback, setIsLoading)
  },
}
export default Vendor
